(function () {
  var WISHLIST_KEYS_PREFIX = 'premium_wishlist_';

  function getAllWishlistHandles() {
    var handles = [];
    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      if (key && key.indexOf(WISHLIST_KEYS_PREFIX) === 0) {
        try {
          var list = JSON.parse(localStorage.getItem(key)) || [];
          list.forEach(function (h) {
            if (handles.indexOf(h) === -1) handles.push(h);
          });
        } catch (e) {}
      }
    }
    return handles;
  }

  function updateBadge() {
    var badge = document.querySelector('[data-mobile-wishlist-badge]');
    if (!badge) return;
    var count = getAllWishlistHandles().length;
    badge.textContent = count > 9 ? '9+' : String(count);
    badge.setAttribute('data-count', String(count));
  }

  function setActiveNavItem() {
    var path = window.location.pathname;
    document.querySelectorAll('.mobile-app-nav__item[data-nav-path]').forEach(function (el) {
      var navPath = el.getAttribute('data-nav-path');
      var isActive = navPath === '/' ? path === '/' : path.indexOf(navPath) === 0;
      if (isActive) {
        el.setAttribute('aria-current', 'page');
      } else {
        el.removeAttribute('aria-current');
      }
    });
  }

  function formatMoney(cents) {
    try {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function renderWishlistDrawer() {
    var list = document.querySelector('[data-mobile-wishlist-list]');
    var empty = document.querySelector('[data-mobile-wishlist-empty]');
    if (!list) return;
    var handles = getAllWishlistHandles();

    list.innerHTML = '';

    if (handles.length === 0) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) {
          if (!product) return;
          var a = document.createElement('a');
          a.href = '/products/' + product.handle;
          a.className = 'mobile-wishlist-item';
          var imgSrc = product.featured_image || (product.images && product.images[0]) || '';
          if (imgSrc) imgSrc = imgSrc + (imgSrc.indexOf('?') > -1 ? '&' : '?') + 'width=104';
          var img = document.createElement('img');
          img.src = imgSrc;
          img.loading = 'lazy';
          img.alt = product.title;
          var info = document.createElement('div');
          info.className = 'mobile-wishlist-item__info';
          var title = document.createElement('p');
          title.className = 'mobile-wishlist-item__title';
          title.textContent = product.title;
          var price = document.createElement('p');
          price.className = 'mobile-wishlist-item__price';
          price.textContent = formatMoney(product.price);
          info.appendChild(title);
          info.appendChild(price);
          a.appendChild(img);
          a.appendChild(info);
          list.appendChild(a);
        })
        .catch(function () {});
    });
  }

  function openWishlistDrawer() {
    var drawer = document.getElementById('mobile-wishlist-drawer');
    if (!drawer) return;
    renderWishlistDrawer();
    drawer.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
  }

  function closeWishlistDrawer() {
    var drawer = document.getElementById('mobile-wishlist-drawer');
    if (!drawer) return;
    drawer.removeAttribute('open');
    document.body.style.overflow = '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateBadge();
    setActiveNavItem();

    var wishlistTrigger = document.querySelector('[data-mobile-wishlist-trigger]');
    if (wishlistTrigger) {
      wishlistTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        openWishlistDrawer();
      });
    }

    var closeBtn = document.querySelector('[data-mobile-wishlist-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeWishlistDrawer);

    var backdrop = document.querySelector('[data-mobile-wishlist-backdrop]');
    if (backdrop) backdrop.addEventListener('click', closeWishlistDrawer);

    window.addEventListener('storage', updateBadge);

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[class*="wishlist-"]')) {
        setTimeout(updateBadge, 50);
      }
    });
  });
})();
